// removed by extract-text-webpack-plugin
module.exports = {"user-container":"user-container","user-header":"user-header"};


//////////////////
// WEBPACK FOOTER
// ./components/layouts/user/_UserLayout.scss
// module id = ./components/layouts/user/_UserLayout.scss
// module chunks = 0